<template>
  <div class="cardBox discountBox">
    <div class="discountResRow fvlru themeColor" :class="{ discountResRowPadding: !isShowDiscountList }">
      <span>平台优惠{{ isShowDiscountList }}</span>
      <div class="discountRes" @click="isShowDiscountList = !isShowDiscountList">
        <span v-if="discountResText">{{ discountResText }}</span>
        <i v-else>请选择优惠券</i>
        <van-icon v-if="isShowDiscountList" name="arrow-up" />
        <van-icon v-else name="arrow-down" />
      </div>
    </div>
    <van-divider v-show="isShowDiscountList" />
    <div v-show="isShowDiscountList" class="discountList">
      <template v-for="item in couponCardDatas" :key="item.id">
        <couponCard
          class="couponCard"
          :class="[couponCardSelect.id == item.id ? 'couponCardSelect' : 'couponCardUnSelect']"
          :isMy="true"
          :datas="item"
          @click="changeDiscount(item)"
        >
          <!-- <couponBtn :data="item.cardBtn" @click="clickBtn($event, item)" /> -->
        </couponCard>
      </template>
      <p v-if="!couponCardDatas || couponCardDatas.length === 0">暂无可使用优惠券</p>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { getCouponDetail } from '@/api/couponCollection'
import { reorganizeListData, showToast } from '@/util/couponCollection'
import couponCard from '@/components/couponCollection/CouponCard'

export default {
  components: {
    couponCard
  },
  props: {
    data: {
      type: [Object, Array],
      default: () => []
    },
    sign: {
      type: String,
      default: ''
    },
    selceted: {
      type: [Object],
      default: () => ({})
    }
  },
  emits: ['emit'],
  setup(props, { emit }) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    let { data, sign, selceted } = toRefs(props)
    const state = reactive({
      data,
      isShowDiscountList: false,
      couponCardDatas: [],
      couponCardSelect: selceted
    })

    const discountResText = computed(() => {
      // TODO，确认id，rightId
      let { subtractPrice = '', fullPrice = '', id, rightId } = state.couponCardSelect?.rightContent || {}
      // '选择的券不在list范围内'
      if (id && rightId && !state.couponCardDatas.find(item => item.id === id && item.rightId === rightId)) {
        changeDiscount({})
        return ''
      }
      return subtractPrice && fullPrice ? `满${fullPrice}减${subtractPrice}` : ''
    })
    watch(
      () => state.data,
      v => {
        try {
          state.couponCardDatas = reorganizeListData(v)
        } catch {
          state.couponCardDatas = []
        }
      },
      { immediate: true }
    )
    const changeDiscount = data => {
      console.log('changeDiscount', data)
      let select = state.couponCardSelect && state.couponCardSelect.id === data.id ? {} : data
      state.couponCardSelect = select
      emit('change', select)
    }
    return {
      ...toRefs(state),
      changeDiscount,
      discountResText
    }
  }
}
</script>
<style lang="scss" scoped>
.discountBox {
}
.orderItemBox,
.discountBox {
  padding: 5px 10px;
}
.discountResRow {
  padding: 10px 10px 0;
}
.discountRes {
  span {
    display: inline-block;
    // margin-right: 10px;
    padding: 3px 10px;
    border: 1px solid #3088c5;
    border-radius: 5px;
  }
  i {
    display: inline-block;
    padding: 3px 0px;
    border: 1px solid transparent;
  }
  .van-icon {
    margin-left: 10px;
  }
}
.discountResRowPadding {
  padding-bottom: 10px;
}
.discountList {
  padding: 0 10px;
}
.couponCard {
  margin-bottom: 12px;
  scale: 0.95;
}
.couponCardSelect {
  border: 1px solid #3088c5;
  border-radius: 15px;
}
.couponCardUnSelect {
  border: 1px solid transparent;
  border-radius: 15px;
}
</style>
